module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入渠道名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入发行游戏名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.pdata.issued_app_name),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "issued_app_name", $$v)
      },
      expression: "pdata.issued_app_name"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.pdata.company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "company_id", $$v)
      },
      expression: "pdata.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择采集来源",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('el-option', {
      key: index + 1,
      attrs: {
        "label": item,
        "value": index + 1
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, -1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.batchProduct
    }
  }, [_vm._v("批量增加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "text"
    },
    on: {
      "click": _vm.downloadTemp
    }
  }, [_vm._v("导入模板下载")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "80px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "app_name",
      "label": "发行游戏名称",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.app_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "采集公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_short_name",
      "label": "对应公司",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ald_channel",
      "label": "对应渠道",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchange",
      "label": "是否换量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.exchange == 0) ? _c('span', [_vm._v("否")]) : (scope.row.exchange == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "采集来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("阿拉丁")]) : (scope.row.type == 2) ? _c('span', [_vm._v("微信")]) : (scope.row.type == 3) ? _c('span', [_vm._v("广点通")]) : (scope.row.type == 4) ? _c('span', [_vm._v("内部矩阵")]) : (scope.row.type == 5) ? _c('span', [_vm._v("阿拉丁换量")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "atv",
      "label": "获客单价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "click_price",
      "label": "点击单价",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "update_time",
      "label": "下线时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status != 1) ? _c('span', [_vm._v(_vm._s(scope.row.update_time))]) : _c('span', [_vm._v(" ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "渠道状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pdata.kw == '' && _vm.pdata.issued_app_name == '' && _vm.pdata.company == '') ? _c('div', [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd == true ? '新增' : '编辑',
      "visible": _vm.editDialog,
      "width": "550px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发行小游戏",
      "prop": "issued_app_id"
    }
  }, [_c('searchApp', {
    attrs: {
      "compare": "issued",
      "pholder": _vm.form.app_name,
      "platform_id": ''
    },
    on: {
      "getid": function (res) {
        _vm.form.issued_app_id = res
      },
      "getInfo": function (r) {
        _vm.form.app_name = r.name
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "xsl_from",
      "prop": "xsl_from"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "xsl_from"
    },
    model: {
      value: (_vm.form.xsl_from),
      callback: function($$v) {
        _vm.$set(_vm.form, "xsl_from", $$v)
      },
      expression: "form.xsl_from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对应渠道",
      "prop": "ald_channel"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入阿拉丁后台对应渠道"
    },
    model: {
      value: (_vm.form.ald_channel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ald_channel", $$v)
      },
      expression: "form.ald_channel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择对应公司",
      "prop": "company_id"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择对应公司"
    },
    model: {
      value: (_vm.form.company_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_id", $$v)
      },
      expression: "form.company_id"
    }
  }, _vm._l((_vm.companys), function(item) {
    return _c('el-option', {
      key: item.company_id,
      attrs: {
        "label": item.company_name,
        "value": item.company_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对应公司",
      "prop": "company"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "company"
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采集来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.config), function(it, idx) {
    return _c('el-radio', {
      key: idx,
      attrs: {
        "label": idx + 1
      }
    }, [_vm._v(_vm._s(it))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导量来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.data_source),
      callback: function($$v) {
        _vm.$set(_vm.form, "data_source", $$v)
      },
      expression: "form.data_source"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("矩阵导量")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("广点通导量")]), _vm._v(" "), _c('el-radio', {
    key: "3",
    attrs: {
      "label": "3"
    }
  }, [_vm._v("外部渠道导量")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否换量"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.exchange),
      callback: function($$v) {
        _vm.$set(_vm.form, "exchange", $$v)
      },
      expression: "form.exchange"
    }
  }, [_c('el-radio', {
    key: "0",
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品归属"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.product_belongs),
      callback: function($$v) {
        _vm.$set(_vm.form, "product_belongs", $$v)
      },
      expression: "form.product_belongs"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("内部矩阵")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("外部渠道")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "买量来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.buy_source),
      callback: function($$v) {
        _vm.$set(_vm.form, "buy_source", $$v)
      },
      expression: "form.buy_source"
    }
  }, [_c('el-radio', {
    key: "1",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-radio', {
    key: "2",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("活跃")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "折扣（0-1）"
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount", $$v)
      },
      expression: "form.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "获客单价",
      "prop": "atv"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "atv"
    },
    model: {
      value: (_vm.form.atv),
      callback: function($$v) {
        _vm.$set(_vm.form, "atv", $$v)
      },
      expression: "form.atv"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点击单价",
      "prop": "click_price"
    }
  }, [_c('el-input', {
    staticClass: "w220",
    attrs: {
      "placeholder": "输入点击单价"
    },
    model: {
      value: (_vm.form.click_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "click_price", $$v)
      },
      expression: "form.click_price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量增加",
      "visible": _vm.batchDialog,
      "width": "1150px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.batchDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [(_vm.batchForm.length == 0) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": _vm.url,
      "headers": _vm.headers,
      "on-success": _vm.batchSuccess,
      "name": "file",
      "show-file-list": false
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]) : _vm._e()], 1), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('el-row', {
    staticClass: "yltt",
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_vm._v(_vm._s(_vm.batchTips))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.batchForm), function(item, index) {
    return (_vm.batchForm.length > 0) ? _c('el-row', {
      key: index,
      staticClass: "yllist",
      class: 'yllist' + index,
      attrs: {
        "gutter": 5
      }
    }, _vm._l((item), function(citem, idx) {
      return _c('el-col', {
        key: idx,
        attrs: {
          "span": 2
        }
      }, [_vm._v("\n       \t\t\t\t" + _vm._s(citem) + "\n       \t\t")])
    }), 1) : _vm._e()
  }), _vm._v(" "), (_vm.batchForm.length > 0) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.batchCalcel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (this.batchTips == '导入预览') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-301b4849"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/channelControl.vue
// module id = 1127
// module chunks = 2